function Dots() {
  return (
    <div className="flex flex-col">
      <div className="h-[30px] bg-[#010A27] z-10  rounded-full aspect-square">
        {/* <div className="h-[40px] bg-[#0F242E] z-10  rounded-full aspect-square"> */}
      </div>
    </div>
  );
}

export default Dots;
